module.exports = __webpack_public_path__ + "img/LINKCO.16d2713.jpg";